var TrialNotification = /** @class */ (function () {
    function TrialNotification(moment, DateFormat, AuthService, $state, $transitions, LanguageService, Router) {
        this.moment = moment;
        this.DateFormat = DateFormat;
        this.dangerLimit = 24 * 5;
        this.AuthService = AuthService;
        this.LanguageService = LanguageService;
        this.$state = $state;
        this.$transitions = $transitions;
        this.isTrialBannerClosedByUser = false;
        this.router = Router;
    }
    TrialNotification.prototype.$onInit = function () {
        var _this = this;
        var _a;
        var expiredDate = this.moment.utc(this.trialExpirationDate, this.DateFormat.localDateTimePattern);
        var statesToHideTrialBanner = [
            'app.blacklist', 'app.lead-generation', 'app.lead-generationPath', 'app.campaign.dashboard',
            'app.campaign.settings', 'app.campaign.import.upload', 'app.campaign.import.history', 'app.numbers.settings',
            'app.pricing', 'app.contacts'
        ];
        var checkIfLessSpaceOnCurrentUrl = function () { return statesToHideTrialBanner.includes(_this.$state.current.name); };
        this.hours = expiredDate.diff(this.moment(), 'hours');
        this.notificationLabel = this.moment.duration(this.hours, "hours").humanize();
        _a = this.notificationLabel.split(' '), this.timeRemaining = _a[0], this.timeUnit = _a[1];
        this.isInDanger = this.hours < this.dangerLimit;
        this.setTrialStatus({ inDanger: this.isInDanger, label: this.notificationLabel });
        this.shouldShowOnlyForBigScreens = checkIfLessSpaceOnCurrentUrl();
        this.$transitions.onSuccess({}, function () {
            _this.shouldShowOnlyForBigScreens = checkIfLessSpaceOnCurrentUrl();
        });
        this.LanguageService.onLanguageChange.subscribe(function () {
            var _a;
            _this.notificationLabel = _this.moment.duration(_this.hours, "hours").humanize();
            _a = _this.notificationLabel.split(' '), _this.timeRemaining = _a[0], _this.timeUnit = _a[1];
        });
    };
    TrialNotification.prototype.isLinkVisible = function () {
        return this.AuthService.hasPermission("PLANS_PERMISSION");
    };
    TrialNotification.prototype.closeTrialBanner = function () {
        this.isTrialBannerClosedByUser = true;
        this.setBannerClosed();
    };
    TrialNotification.prototype.goToChoosePlan = function () {
        this.router.navigateByUrl('/choose-plan');
    };
    TrialNotification.$inject = ['moment', 'DateFormat', 'AuthService', '$state', '$transitions', 'LanguageService', 'Router'];
    return TrialNotification;
}());
export default {
    controller: TrialNotification,
    template: require('./trial.html'),
    bindings: {
        trialExpirationDate: '<',
        setTrialStatus: '&'
    }
};
